<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      custom-class="pb-4 dialog-kyc">
    <div class="text-center">
      <h6>Account Activated 🎉</h6>
      <div>
        <p class="mb-4">
          Your account is now enabled for calling! To start sending text messages, complete your A2P 10DLC brand and
          campaign registration.
          <a href="https://support.aloware.com/en/collections/9373735-a2p-10dlc-registration"
             class="text-blue-14"
             target="_blank">
            Learn more.
          </a>
        </p>
        <el-button type="primary"
                   class="compliance-btn mb-2"
                   @click="goToCompliance">
          Go to Compliance
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VueCookies from 'vue-cookies'
import auth from '../../auth'

export default {
  name: 'SubscriptionSuccessPopup',

  data() {
    return {
      dialogVisible: false,
      cookieName: 'subscription-success',
      profile: auth.user.profile
    }
  },

  computed: {
    parsedCookieName() {
      return `${this.cookieName}-${this.profile?.id}`
    }
  },

  methods: {
    show() {
      if (!this.$cookies.get(this.parsedCookieName)) {
        this.dialogVisible = true
      }
    },

    closeDialog() {
      this.dialogVisible = false
      // Set cookie to expire in 10 years
      this.$cookies.set(this.parsedCookieName, 'viewed', 3650)
    },
    
    goToCompliance() {
      this.closeDialog()
      window.location.href = '/account?tab=compliance'
    }
  },

  watch: {
    dialogVisible(value) {
      if (!value) {
        this.closeDialog()
      }
    }
  },

  created() {
    this.$cookies = VueCookies
  }
}
</script>

<style>
.compliance-btn {
  font-size: 14px !important;
}
</style>